import { describeCombo, type Binding } from '@/shared/lib/shortcuts';

import styles from './ShortcutKeys.module.css';

interface Props {
  binding: Binding;
  /** Shown when the action has no shortcut. */
  emptyLabel: string;
  /** Word between the steps of a two-key sequence ("then"). */
  thenLabel: string;
}

/** A binding as small key caps (`Ctrl` `K`, `G` then `W`); Russian-layout twins are shown muted. */
export function ShortcutKeys({ binding, emptyLabel, thenLabel }: Props) {
  if (binding.length === 0) return <span className={styles.empty}>{emptyLabel}</span>;
  return (
    <span className={styles.keys}>
      {binding.map((combo, index) => {
        const label = describeCombo(combo);
        return (
          <span key={`${combo}-${String(index)}`} className={styles.step}>
            {index > 0 && <span className={styles.then}>{thenLabel}</span>}
            {label.modifiers.map((modifier) => (
              <kbd key={modifier} className={styles.key}>
                {modifier}
              </kbd>
            ))}
            <kbd className={styles.key}>{label.key}</kbd>
            {label.ruKey && (
              <span className={styles.ru} aria-hidden>
                / <kbd className={styles.key}>{label.ruKey}</kbd>
              </span>
            )}
          </span>
        );
      })}
    </span>
  );
}
